import React from "react";
import FaqOne from "../component/faq/FaqOne";
import SEO from "../common/SEO";
import HeaderOne from "../common/header/HeaderOne";
import BcrumbBannerOne from "../elements/breadcrumb/BcrumbBannerOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import FooterOne from "../common/footer/FooterOne";
import ServiceData from "../data/service/ServiceMain.json";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import { slugify } from "../utils";
import { useParams } from "react-router-dom";
import AboutThree from "../component/about/AboutThree";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import BcrumbBannerTwo from "../elements/breadcrumb/BcrumbBannerTwo";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ClientSlider from "../component/client/ClientSlider";

const allServiceData = ServiceData;
const FAQs = () => {
  const params = useParams();
  const serviceSlug = params.slug;

  const getServiceData = allServiceData.filter(
    (data) => slugify(data.title) === serviceSlug
  );
  const detailsService = getServiceData[0];
  return (
    <>
      <SEO title="Service Details" />
      {/* <ColorSwitcher /> */}
      <main className="main-wrapper">
        <HeaderOne />
        {/* <BcrumbBannerOne
          title={"FAQs"}
          paragraph={"dasd"}
          styleClass=""
          // mainThumb="/images/banner/banner-thumb-4.png"
          mainThumb="/images/banner/main-banner.png"
        /> */}
         <BreadCrumbOne
          subtitle=""
          title="FAQs"
          page="FAQs"
        />
        {/* <BcrumbBannerTwo
          title="FAQs"
          paragraph="Find quick answers to common questions about our services! Explore topics like pricing, process, timelines, and support to make informed decisions. Our FAQ section is here to ensure you have everything you need for a seamless experience."
          styleClass=""
          // mainThumb="/images/banner/banner-thumb-4.png"
          mainThumb="/images/banner/industry-img.jpg"
        /> */}

        <FaqOne />

        {/* <AboutTwo /> */}

        {/* <div className="section section-padding bg-color-light pb--70">
                <SectionTitle
                    subtitle={""}
                    title={"dsad"}
                    description={"dsda"}
                    textAlignment=""
                    textColor="mb--90"
                />
                
                <ul className="shape-group-17 list-unstyled">
                    <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-24.png"} alt="Bubble" /></li>
                    <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-23.png"} alt="Bubble" /></li>
                    <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/line-4.png"} alt="Line" /></li>
                    <li className="shape shape-4"><img src={process.env.PUBLIC_URL + "/images/others/line-5.png"} alt="Line" /></li>
                    <li className="shape shape-5"><img src={process.env.PUBLIC_URL + "/images/others/line-4.png"} alt="Line" /></li>
                    <li className="shape shape-6"><img src={process.env.PUBLIC_URL + "/images/others/line-5.png"} alt="Line" /></li>
                </ul>
            </div> */}
        {/* <div className="section section-padding">
                <div className="container">
                    <SectionTitle 
                        subtitle="Our Project"
                        title="Featured Designs"
                        description=""
                        textAlignment=""
                        textColor=""
                    />
                    
                </div>
                <ul className="shape-group-16 list-unstyled">
                    <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/circle-2.png"} alt="circle" /></li>
                    <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"} alt="Line" /></li>
                </ul>
            </div> */}
        {/* <CounterUpTwo /> */}
        <CounterUpTwo />
        <AboutThree />
        <div className="container "style={{paddingTop:'100px'}} >
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>
        {/* // In your page/component: */}
        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35" 
          parentClass="your-custom-class"
        />
        {/* <CtaLayoutOne /> */}
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default FAQs;
